import {
  useAdminInvoiceReportJournalEntries,
  type InvoiceReportDetailJournalEntriesResponse,
} from '@/context/services/admin_invoice_reports/AdminInvoiceReportJournal.service';
import { useMemo } from 'react';

export const useJournalEntries = (reportId: string) => {
  const { data } = useAdminInvoiceReportJournalEntries(reportId);
  const listColumns = useMemo(() => {
    return data?.entry_fields ?? [];
  }, [data]);

  const items = useMemo(() => {
    const source: InvoiceReportDetailJournalEntriesResponse =
      data?.entries ?? [];
    return source.map((item, index: number) => ({
      ...item,
      id: `${reportId}-${index}`,
    }));
  }, [data, reportId]);

  return { data: items, listColumns };
};

export const useDefaultPagination = () => {
  return useMemo(
    () => ({
      currentPage: 1,
      maxPage: 1,
      perPage: 1,
      maxRecord: 0,
    }),
    []
  );
};
